import { useNavigate } from "react-router-dom";
import "../css/ForumFixovera.css";

// Import required asset paths (adjust paths based on your file structure)
import featureSectionBg2 from "../../images/Banner2.png";


import {
    FaUserCheck, FaCalendarCheck, FaHome, FaHeadset
} from "react-icons/fa";



function ForumCrestest() {
    const navigate = useNavigate();

    return (
        <section className="forum-grid-bg-section" style={{ backgroundImage: `url(${featureSectionBg2})` }}>
            <div className="container forum-content-layer">


                {/* Centralized Section Header */}
                <div className="row justify-content-center text-center mb-5">
                    <div className="col-lg-8">

                        <span
                            className="forum-grid-mini-tag"
                            style={{
                                color: "#73DEBD",
                                fontWeight: 700,
                                letterSpacing: "2px"
                            }}
                        >
                            WHY CHOOSE FIXOVERA
                        </span>

                        <h2
                            className="forum-grid-heading"
                            style={{
                                color: "#FFFFFF",
                                fontWeight: 800
                            }}
                        >
                            Reliable Home Services, Made Simple
                        </h2>

                        <div
                            className="forum-zigzag-border mx-auto mt-3"
                            style={{
                                background:
                                    "linear-gradient(90deg, #5D51B3, #8751A0, #BE59B1, #3BAE9F, #73DEBD)"
                            }}
                        ></div>

                    </div>
                </div>


                {/* 2 Cards Per Row */}
                <div className="row g-4 justify-content-center mb-5">


                    {/* Trusted Professionals */}
                    <div className="col-lg-6">
                        <div
                            className="forum-glass-box"
                            style={{
                                background: "#222B55",
                                border: "1px solid #5D51B3"
                            }}
                        >
                            <div className="forum-box-inner">

                                <div
                                    className="forum-square-icon-wrapper"
                                    style={{
                                        background: "rgba(93, 81, 179, 0.18)",
                                        border: "2px solid #5D51B3",
                                        color: "#7B87D3"
                                    }}
                                >
                                    <FaUserCheck
                                        style={{
                                            fontSize: "32px",
                                            color: "#7B87D3"
                                        }}
                                    />
                                </div>

                                <div className="forum-box-text-block">

                                    <h4
                                        style={{
                                            color: "#FFFFFF",
                                            fontWeight: 700
                                        }}
                                    >
                                        Trusted Professionals
                                    </h4>

                                    <p
                                        style={{
                                            color: "#FFFFFF",
                                            fontWeight: 500,
                                            lineHeight: 1.5
                                        }}
                                    >
                                        Connect with skilled professionals for your household
                                        needs and get dependable assistance for repairs,
                                        maintenance, cleaning, and other essential services.
                                    </p>

                                </div>

                            </div>
                        </div>
                    </div>


                    {/* Easy Booking */}
                    <div className="col-lg-6">
                        <div
                            className="forum-glass-box"
                            style={{
                                background: "#131A34",
                                border: "1px solid #BE59B1"
                            }}
                        >
                            <div className="forum-box-inner">

                                <div
                                    className="forum-square-icon-wrapper"
                                    style={{
                                        background: "rgba(190, 89, 177, 0.18)",
                                        border: "2px solid #BE59B1",
                                        color: "#BE59B1"
                                    }}
                                >
                                    <FaCalendarCheck
                                        style={{
                                            fontSize: "32px",
                                            color: "#BE59B1"
                                        }}
                                    />
                                </div>

                                <div className="forum-box-text-block">

                                    <h4
                                        style={{
                                            color: "#FFFFFF",
                                            fontWeight: 700
                                        }}
                                    >
                                        Easy & Convenient Booking
                                    </h4>

                                    <p
                                        style={{
                                            color: "#FFFFFF",
                                            fontWeight: 500,
                                            lineHeight: 1.5
                                        }}
                                    >
                                        Find the service you need, choose a convenient
                                        schedule, and manage your household service requests
                                        through a simple and convenient booking experience.
                                    </p>

                                </div>

                            </div>
                        </div>
                    </div>


                    {/* Complete Home Services */}
                    <div className="col-lg-6">
                        <div
                            className="forum-glass-box"
                            style={{
                                background: "#1F505F",
                                border: "1px solid #3BAE9F"
                            }}
                        >
                            <div className="forum-box-inner">

                                <div
                                    className="forum-square-icon-wrapper"
                                    style={{
                                        background: "rgba(59, 174, 159, 0.18)",
                                        border: "2px solid #3BAE9F",
                                        color: "#73DEBD"
                                    }}
                                >
                                    <FaHome
                                        style={{
                                            fontSize: "32px",
                                            color: "#73DEBD"
                                        }}
                                    />
                                </div>

                                <div className="forum-box-text-block">

                                    <h4
                                        style={{
                                            color: "#FFFFFF",
                                            fontWeight: 700
                                        }}
                                    >
                                        Complete Home Services
                                    </h4>

                                    <p
                                        style={{
                                            color: "#FFFFFF",
                                            fontWeight: 500,
                                            lineHeight: 1.5
                                        }}
                                    >
                                        From cleaning, plumbing, and electrical work to AC,
                                        appliance, painting, carpentry, and pest control,
                                        Fixovera brings essential household services together
                                        in one platform.
                                    </p>

                                </div>

                            </div>
                        </div>
                    </div>


                    {/* Seamless Service Experience */}
                    <div className="col-lg-6">
                        <div
                            className="forum-glass-box"
                            style={{
                                background: "#5D51B3",
                                border: "1px solid #7B87D3"
                            }}
                        >
                            <div className="forum-box-inner">

                                <div
                                    className="forum-square-icon-wrapper"
                                    style={{
                                        background: "rgba(123, 135, 211, 0.18)",
                                        border: "2px solid #7B87D3",
                                        color: "#FFFFFF"
                                    }}
                                >
                                    <FaHeadset
                                        style={{
                                            fontSize: "32px",
                                            color: "#FFFFFF"
                                        }}
                                    />
                                </div>

                                <div className="forum-box-text-block">

                                    <h4
                                        style={{
                                            color: "#FFFFFF",
                                            fontWeight: 700
                                        }}
                                    >
                                        Seamless Service Experience
                                    </h4>

                                    <p
                                        style={{
                                            color: "#FFFFFF",
                                            fontWeight: 500,
                                            lineHeight: 1.5
                                        }}
                                    >
                                        Manage your service journey with convenient
                                        communication, booking updates, service tracking,
                                        and dedicated support designed to make home
                                        maintenance easier.
                                    </p>

                                </div>

                            </div>
                        </div>
                    </div>


                </div>


            </div>

        </section>
    );
}

export default ForumCrestest;